import {FC, useState} from "react";
import Image from 'react-bootstrap/Image';
import {toAbsoluteUrl} from "../../../../../_kiloit/helpers";
import {chips, currencyTypes} from "../../../../constants/general";
import {useAppSelector} from "../../../../redux/hooks/hook";
import {BetPrice, BetType} from "../../../config/_models";
import {BetItem, BetModel, DrawModel} from "../../core/_models";
import {useGame} from "../../core/action";
import {useConfig} from "../../../config/action";
import clsx from "clsx";
import {getLocalSt} from "../../../../../_kiloit/helpers/storage";
import {clickId} from "../../../../../_kiloit/helpers/utils";

type props = {
    draw?: DrawModel,
}

const BetPriceCard = ({item, index, activeChip, onChangeChip}) => {
    let chipGif = chips[index] ?? chips[0];
    if (activeChip?.value === item?.value)
        return <div onClick={() => onChangeChip(item)} className="btn-chip on" key={index}>
            {/*<img src={toAbsoluteUrl(`/media/chips/up/${chipGif}.gif`)} alt=""/>*/}
            <Image className="bg-transparent border-0 shadow-none"
                   src={toAbsoluteUrl(`/media/chips/up/${chipGif}.gif`)} thumbnail/>
            <div className="sell-chip bg_chip10">
                <span className="fs-5">{item.label}</span>
            </div>
        </div>
    return <div onClick={() => onChangeChip(item)} className="btn-chip" key={index}>
        {/*<img src={toAbsoluteUrl(`/media/chips/${chipGif}.png`)} alt=""/>*/}
        <Image className="bg-transparent border-0 shadow-none" src={toAbsoluteUrl(`/media/chips/${chipGif}.png`)}
               thumbnail/>
        <div className="sell-chip bg_chip10">
            <span className="fs-5">{item.label}</span>
            <div className="bg_chip_rdBK"/>
        </div>
    </div>
}

const BetCardRange = ({betType, onBet, enableBetting}) => {
    return <div onClick={() => onBet(betType)} className="col-4">
        <div className={clsx("rounded-1 bg-opacity-25 p-0 border-0", {
            "bg-hover-danger cursor-pointer": enableBetting
        })}>
            <Image className="bg-transparent border-0 p-2 shadow-none"
                   src={toAbsoluteUrl(`/media/dice/${betType.betCode}.png`)} alt="---" thumbnail/>
        </div>
    </div>
}

const BetCardSlot = ({betType, enableBetting, onBet}) => {
    return <div className="col-2" onClick={() => onBet(betType)}>
        <div className={clsx("rounded-1 bg-opacity-25", {
            "bg-hover-danger cursor-pointer": enableBetting
        })}>
            <Image className="bg-transparent border-0 shadow-none"
                   src={toAbsoluteUrl(`/media/dice/${betType.betCode}.png`)}
                   thumbnail/>
        </div>
    </div>
}
const BettingBoard: FC<props> = ({draw}) => {
    const config = useAppSelector(state => state.config.gameConfig);
    const bl = useAppSelector(state => state.balance.balance);
    const game = useAppSelector(state => state.gameState.game);
    const [activeChip, setChip] = useState<BetPrice>();
    const {postBetting} = useGame();
    const {rages, slots} = useConfig().getBetType();
    const [betAmount, setBetAmount] = useState(0);
    const autoPrint = getLocalSt("isChecked") === "true"

    const isValidBetAmount = () => {
        if (betAmount > 0) {
            if (bl.currencyCode === currencyTypes.khr) {
                if (betAmount % 1000 !== 0) {
                    return false;
                }
            }
        } else {
            return false
        }
        return true;
    }


    const enableBetting = game.countDown > 5 && isValidBetAmount();


    const onBet = (betType: BetType) => {
        if (!enableBetting) {
            return;
        }
        const bItem: BetItem = {
            betCode: betType.betCode,
            betAmount: betAmount,
            currencyCode: bl.currencyCode,
            betLog: betAmount.toString(),
        }
        const bm: BetModel = {
            tableId: draw?.tableId,
            items: [
                bItem
            ]
        }
        handleDelete();
        postBetting(bm).then(() => {
            autoPrint && clickId("print-button");
        });
    }

    const handleDelete = () => {
        setBetAmount(0);
        setChip(undefined);
    }


    const onChangeChip = (chip: BetPrice) => {
        setChip(chip);
        const ba = betAmount + chip.value;
        setBetAmount(ba);
    }


    return <div className="p-2">
        <div className="row btn-bet-type">
            {slots.map((betType, index) => {
                return <BetCardSlot key={index} onBet={onBet} enableBetting={enableBetting} betType={betType}/>
            })}
        </div>
        <div className="row mt-2 mb-2">
            {
                rages.map((betType, index) => {
                    return <BetCardRange betType={betType} enableBetting={enableBetting} onBet={onBet} key={index}/>
                })
            }
        </div>

        <div className="d-flex align-items-center justify-content-between flex-column">
            <div className="d-flex align-items-center w-100 px-2">
                <div className="w-100">
                    <input type="number" className="w-100 fs-2 rounded text-info text-center fw-bold"
                           value={betAmount}
                           onChange={(e) => setBetAmount(Number(e.target.value))}/>
                </div>
                <div id="clear-am-btn" className="btn bg-danger text-light fw-bold radius-unset py-2 ms-2"
                     onClick={handleDelete}>
                    Clear
                </div>
            </div>
            <div className="d-flex justify-content-evenly w-100">
                {config.betPrice.map((item, index) => {
                    return <div key={index} className="p-0 d-flex justify-content-center">
                        <BetPriceCard item={item} index={index} activeChip={activeChip} onChangeChip={onChangeChip}
                                      key={index}/>
                    </div>
                })}
            </div>

        </div>
    </div>
}
export default BettingBoard;